export default __webpack_public_path__ + "static/media/lightbulb_dark.b4752dcd.svg";